import React, { useEffect } from 'react'
import { propertyTypeOptions, propertyTypeValueMap } from '../../PropertyType'
import styles from '../modal.module.css'
// import Tooltip from '@mui/material/Tooltip';
import infoIcon from './images/circle-info-regular-full.svg'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'

const useTooltipStyles = makeStyles({
  tooltip: {
    display: 'inline-block',
    width: 'auto',
    maxWidth: 500,
    fontSize: '13px',
    padding: '8px',
    whiteSpace: 'normal',
    lineHeight: 1.4,
    textAlign: 'left',
    wordBreak: 'break-word'
  }
})

// function PropertyType({ onApplyFilters }) {
function PropertyType ({ localPropertyType, setLocalPropertyType }) {
  const toolTipClasses = useTooltipStyles()

  const handlePropertyTypeClick = typeLabel => {
    const typeValue = propertyTypeValueMap[typeLabel] || typeLabel

    let newTypes
    if (localPropertyType.includes(typeValue)) {
      // Remove the type if it's already selected
      newTypes = localPropertyType.filter(t => t !== typeValue)
    } else {
      // Add the type if it's not already selected
      newTypes = [...localPropertyType, typeValue]
    }

    // If no types are selected, default back to ["Any"]
    if (newTypes.length === 0) {
      newTypes = ['Any']
    }

    setLocalPropertyType(newTypes)
  }

  useEffect(() => {
    // Remove "Any" from the array if it exists
    if (localPropertyType.includes('Any')) {
      const filteredTypes = localPropertyType.filter(type => type !== 'Any')
      setLocalPropertyType(filteredTypes)
    }
  }, [localPropertyType, setLocalPropertyType])

  // Rest of your component...

  return (
    <div>
      <section className={styles.propertyTypeSection}>
        <div className={styles.sectionTitleWithIcon}>
          <h1 className={styles.sectionHeading}>Property type</h1>
          <Tooltip
            title='Filter by property type. Select one or more; results match any selected type.'
            arrow
            placement='top'
            classes={{ tooltip: toolTipClasses.tooltip }}
          >
            <img
              src={infoIcon}
              alt='Property type help'
              width={14}
              height={14}
              className={styles.infoIcon}
              tabIndex={0}
              style={{ marginTop: '1px' }}
            />
          </Tooltip>
        </div>

        <h2 className={styles.propertyTypeLabelTitle}>
          Select multiple options if needed.
        </h2>
        <div className={styles.propertyTypeButtons}>
          {propertyTypeOptions
            .filter(option => option !== 'Any')
            .map(typeLabel => (
              <button
                key={typeLabel}
                id={typeLabel}
                name={typeLabel}
                className={`${styles.propertyTypeButton} ${
                  localPropertyType.includes(
                    propertyTypeValueMap[typeLabel] || typeLabel
                  )
                    ? styles.active
                    : ''
                }`}
                onClick={() => handlePropertyTypeClick(typeLabel)}
              >
                {typeLabel}
              </button>
            ))}
        </div>
      </section>
      <hr className={styles.hrStyle} />
    </div>
  )
}

export default PropertyType
